// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-style{
  color: rgb(210, 4, 45);
  background: none;
  border: none;
  font-size: 1rem;
}

.alert-modal .ant-modal-footer {
    display: flex;
    justify-content: center;
}

.alert-modal .ant-btn-color-primary{
    background: #d2042d !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/alert-message-modal/AlertMessageModal.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":[".alert-style{\n  color: rgb(210, 4, 45);\n  background: none;\n  border: none;\n  font-size: 1rem;\n}\n\n.alert-modal .ant-modal-footer {\n    display: flex;\n    justify-content: center;\n}\n\n.alert-modal .ant-btn-color-primary{\n    background: #d2042d !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
